import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppShell from "./components/layout/AppShell";
import ScrollToTop from "./components/layout/ScrollToTop";
import AdminPage from "./pages/AdminPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import PricingPage from "./pages/PricingPage";
import RealizationsPage from "./pages/RealizationsPage";
import ServicesPage from "./pages/ServicesPage";

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<HomePage />} />
          <Route path="sluzby" element={<ServicesPage />} />
          <Route path="cenik" element={<PricingPage />} />
          <Route path="realizace" element={<RealizationsPage />} />
          <Route path="kontakt" element={<ContactPage />} />
          <Route path="admin" element={<AdminPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
